import React from 'react';
import { filter, includes, reduce, sortBy } from 'lodash';
import numeral from 'numeral';

export const extractValue = (data, key) => {
  const value = data[key];
  if (value === 0) return '0';
  if (!value) return '-';
  return value;
};

export const maxScore = mobilityData =>
  reduce(mobilityData, (max, score) => (score > max ? score : max), 0);

export const contentReportTabConversion = tab => {
  if (tab.includes('ngagement')) {
    return 'engagement';
  } else if (tab.includes('iewership')) {
    return 'audience';
  } else if (tab.includes('ffinity')) {
    return 'affinity';
  }

  return 'anticipation';
};

export const getTabNameFromPath = (history, contentId) => {
  const paths = history.location.pathname.split('/');
  const lastPath = paths[paths.length - 1];
  if (lastPath !== contentId) {
    return lastPath;
  }

  return 'anticipation';
};

export const truncateText = (str, maxCharacters = 40) => {
  if (!str) {
    return '';
  }

  if (str.length <= maxCharacters) {
    return str;
  }

  return `${str.substring(0, maxCharacters)}...`;
};

export const formatToNumber = (value = 0) => numeral(value).format('0,0');

export const sortPlatforms = (data = []) => {
  const supportedUnknownPlatforms = ['Unofficial', 'Other'];
  const platformsData = filter(
    data,
    ({ voteCount }) => Math.round(voteCount) !== 0
  );
  const unknownPlatforms = filter(platformsData, ({ platformName }) =>
    includes(supportedUnknownPlatforms, platformName)
  );
  const knownPlatforms = filter(
    platformsData,
    ({ platformName }) => !includes(supportedUnknownPlatforms, platformName)
  );
  return [
    ...sortBy(unknownPlatforms, ({ voteCount }) => voteCount),
    ...sortBy(knownPlatforms, ({ voteCount }) => voteCount)
  ].reverse();
};

export const formatToPercent = (value = 0) => {
  let formatting = '';
  if (value < 0.01) {
    formatting = '0.000%';
  } else if (value < 0.1) {
    formatting = '0.00%';
  } else if (value < 1) {
    formatting = '0.0%';
  } else {
    formatting = '0%';
  }
  return numeral(value / 100).format(formatting);
};

export const addBulletIfSet = content => {
  if (content !== null && content !== '' && content !== 0) {
    return <span className="inline-bullet"> • </span>;
  }
  return <></>;
};

export const integerValueFields = [
  'network',
  'show',
  'studio',
  'season',
  'episode',
  'title'
];
export const stringValueFields = [
  'genre',
  'originating_country',
  'country',
  'age',
  'gender',
  'movie',
  'platform'
];
export const multiLabelFields = [
  'Network',
  'Show',
  'Movie',
  'Studio',
  'Genre',
  'Originating Country',
  'Country',
  'Age Group of Fans',
  'Gender',
  'Season',
  'Episode'
];
export const anticipationTitles = ['Age', 'Gender', 'Region', 'Panel'];
export const attributionTitles = [
  'Age',
  'Gender',
  'Region',
  'Panel',
  'Date',
  'Report Date',
  'Platform',
  'Content Type',
  'Network/Studio',
  'Genre',
  'Release Date'
];

export const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
export const isUUID = v => uuidRegex.test(v);

export default {
  extractValue,
  maxScore,
  contentReportTabConversion,
  truncateText,
  sortPlatforms,
  formatToPercent,
  addBulletIfSet,
  integerValueFields,
  stringValueFields,
  multiLabelFields,
  uuidRegex,
  isUUID,
  anticipationTitles,
  attributionTitles
};
